module.exports = __webpack_public_path__ + "img/4w2.edfc14e9.jpg";